import { observer } from 'mobx-react-lite'
import { Icon } from 'shared/ui'
import { makeTextFieldClear, TextField } from 'shared/ui/TextField'
import { useTaggedContactsContext } from 'pages/settings/pages/tags/context/taggedContactsContext'
import styles from './styles.module.scss'

export const TaggedContactsPageSearch = observer(() => {
  const { search, setSearch } = useTaggedContactsContext()

  return (
    <div className={styles.search}>
      <Icon icon='search' color='secondary' fontSize={20} padding={6} tertiary />
      <TextField
        className={styles.field}
        variant='integrated'
        InputProps={{
          placeholder: 'Search...',
        }}
        onChange={setSearch}
        value={search}
        rightActions={[
          makeTextFieldClear({
            isButton: true,
            isVisibleWithoutFocus: true,
          }),
        ]}
      />
    </div>
  )
})
